//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import moment from 'moment';
import { ExceptionManager } from 'Core/logManager';

//action types
import {
    PREFERENCES_GET_PREFERENCES_REQUEST,
    PREFERENCES_SAVE_PREFERENCE,
} from 'Redux/actionTypes';

//actions
import {
    getPreferencesResult,
    updatePreferenceView
} from 'Redux/actions';

function* getPreferencesRequest({ payload }) {
    try {
        const { entityName, entityId, force = false } = payload;
        let getDataServer = false;
        let data, preferences = []
        if (!force) {
            data = localStorage.getItem("preferencesOther");
            if (data) data = JSON.parse(data);
            if (data && data.date) {
                let date = moment(data.date).add(600, 'seconds');
                if (date > moment()) {
                    preferences = data.data
                }
                else getDataServer = true;
            }
            else getDataServer = true;
        }
        else getDataServer = true;

        let QUERY = `query ($projectKey: ProjectKey!, $entityName: EntityName!, $entityId: String!, $preferenceKey: [String]){
            Preferences: searchPreferences (projectKey: $projectKey, entityName: $entityName, entityId: $entityId, preferenceKeys: $preferenceKey) {
                id
                entityName
                entityId
                preferenceKey
                preferenceValue
            }
        }`

        if (getDataServer) {
            data = yield call(
                clientQuery,
                QUERY,
                {
                    projectKey: "PM",
                    entityName,
                    entityId
                },
                endpoints.PX_CLOUD_API,
            );

            if (data && data.Preferences) {
                data = { date: moment(), data: data.Preferences }
                localStorage.setItem("preferencesOther", JSON.stringify(data))
                preferences = data.data
            }
        }
        let result = {}
        result.preferencesOther = preferences;

        yield put(getPreferencesResult(result))

    } catch (exc) {
        // ALWAYS RETURN ACTION
       /*  ExceptionManager(
            exc,
            'Core/containers/Preferences/redux/saga',
            'getPreferencesRequest'
        ); */
        yield put(getPreferencesResult({}))
    }
}

export function* getPreferences() {
    yield takeEvery(PREFERENCES_GET_PREFERENCES_REQUEST, getPreferencesRequest)
}

export function* savePreference() {
    yield takeEvery(PREFERENCES_SAVE_PREFERENCE, function* ({ payload }) {
        try {
            const { entityName, entityId, preferenceKey, preferenceValue } = payload;
            yield call(
                clientMutation,
                ` mutation savePreference ($projectKey: ProjectKey!, $entityName: EntityName!, $entityId: String!, $preferenceKey: String!, $preferenceValue: AWSJSON!){
                    preference: savePreference (projectKey: $projectKey, entityName: $entityName, entityId: $entityId, preferenceKey: $preferenceKey, preferenceValue: $preferenceValue) {
                        id
                    }
                }`,
                {
                    projectKey: "PM",
                    entityName,
                    entityId,
                    preferenceKey,
                    preferenceValue: JSON.stringify(preferenceValue)
                },
                endpoints.PX_CLOUD_API,
            );

            let data = localStorage.getItem("preferencesOther");
            if (data) data = JSON.parse(data);
            else data = { date: moment(), data: [] }

            let dataPreferences = data.data;
            let index = dataPreferences.findIndex(x => x.preferenceKey === preferenceKey)

            if (index === -1) {
                yield call(getPreferencesRequest, { payload: { entityName, entityId, force: true } })
            }
            else {
                dataPreferences[index].preferenceValue = JSON.stringify(preferenceValue);
                data = { date: moment(), data: dataPreferences }
                localStorage.setItem("preferencesOther", JSON.stringify(data))
            }
            yield put(updatePreferenceView(false)); //update the other views

        } catch (exc) {
            // ALWAYS RETURN ACTION
            /* ExceptionManager(
                exc,
                'Core/containers/Preferences/redux/saga',
                'savePreference'
            ); */
            yield put(updatePreferenceView(false)); //update the other views
        }
    });
}

//MERGE SAGA
export default function* rootSaga() {
    yield all([
        fork(getPreferences),
        fork(savePreference)
    ]);
}
